import { useQuery } from '@tanstack/react-query';

import JurisdictionRepository from '@/repositories/JurisdictionRepository';

const useJurisdictions = () => {
  const jurisdictionRepository = JurisdictionRepository();

  return useQuery({
    queryKey: ['jurisdictions'],
    queryFn: () => jurisdictionRepository.getJurisdictions()
  });
};

export default useJurisdictions;
